interface fireActionProps {
  cb?: () => void;
  message?: string;
  runAction?: (args?: any) => void;
}
const useAction = (): { fireAction: any } => {
  const fireAction = async ({ runAction }: fireActionProps): Promise<any> => {
    if (runAction) {
      document.body.classList.add('no-Events');
      await runAction();
      document.body.classList.remove('no-Events');
      return;
    }
  };

  return {
    fireAction,
  };
};

export default useAction;
